<template>
  <div class="root">
    <div class="media" :style="styleMap" :class="classMap" data-inspect="picture">
      <img :loading="blok.lazy_load ? 'lazy' : 'eager'"
        :src="transformImage(mediaSource, blok.transform ?? '1600 x 900', true)" :alt="blok.asset.alt || 'Asset'">
    </div>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  name: "cms-picture",
  mixins: [cms],
  computed: {
    mediaSource() {
      // if (!this.dark) {
        return this.blok.asset.filename
      // }
      // return this.blok.dark_asset?.filename || this.blok.asset.filename
    },
    classMap() {
      return {
        'shadow': this.blok.shadow
      }
    },
    styleMap() {
      return {
        "--_fit": this.blok.fit,
        "--_aspect": this.blok.aspect_ratio
      }
    }
  }
}
</script>

<style scoped>
div.media {
  border-radius: 5px;
  overflow: hidden;
}
div.media.shadow {
  box-shadow: var(--crf-shadow);
}

div.media img {
  object-fit: var(--_fit);
  aspect-ratio: var(--_aspect);
  display: block;
  margin-inline: auto;
  max-width: 1920px;
  width: 100%;
}
</style>
